<span class="pill px-2" [ngClass]="{ live: formattedDate === 'Live', finished: formattedDate === 'Finished', upcoming: formattedDate === 'Upcoming' }">
  <span *ngIf="formattedDate === 'Live' || formattedDate === 'Finished' || formattedDate === 'Upcoming'"></span>
  {{ formattedDate }}
</span>
